<template>
  <div class="target-launch">
    <h4 class="header">
      {{ title }}
    </h4>

    <RtlsCalendarPicker
      :value="dateValue"
      :disabled="disabled"
      :display-date-format="getDateFormats.long"
      class="dense-calendar"
      offset-x
      bold-text
      @input="changeTargetLaunchDate"
    />
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useDayjs } from '@/composables/use-dayjs';
import { useContextStore } from '@/stores/context';

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },

    title: {
      type: String,
      required: false,
      default: '',
    },

    modelValue: {
      type: String,
      required: false,
    },
  },

  emits: ['update:modelValue'],

  setup() {
    const { formatDateForPicker } = useDayjs();
    return { formatDateForPicker };
  },
  computed: {
    ...mapState(useContextStore, ['getDateFormats', 'getDefaultReverseFormat']),

    dateValue() {
      return this.formatDateForPicker(this.modelValue, this.getDefaultReverseFormat);
    },
  },

  methods: {
    changeTargetLaunchDate(date) {
      this.$emit('update:modelValue', date);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.target-launch {
  min-width: 90px;

  :deep(.v-input--is-disabled .v-input__append-inner .v-icon g) {
    stroke: $assortment-disabled-icon-colour;
  }
}
</style>
